import { createApp } from "vue";
import App from "./App.vue";

import router from "./router";

import PrimeVue from "primevue/config";
import "primevue/resources/themes/lara-light-indigo/theme.css";
import "./App.scss";

import StyleClass from "primevue/styleclass";
import Ripple from "primevue/ripple";
import MenuBar from "primevue/menubar";
import Button from "primevue/button";
import Galleria from "primevue/galleria";
import Carousel from "primevue/carousel";
import InputText from "primevue/inputtext";
import Chip from "primevue/chip";
import Dropdown from "primevue/dropdown";
import Card from "primevue/card";
import MultiSelect from "primevue/multiselect";
import Dialog from "primevue/dialog";
import RadioButton from "primevue/radiobutton";
import Toast from "primevue/toast";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Divider from "primevue/divider";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Paginator from "primevue/paginator";
import ToastService from "primevue/toastservice";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import TextArea from "primevue/textarea";
import ScrollPanel from "primevue/scrollpanel";
import Tooltip from "primevue/tooltip";

import httpInterceptorMixin from "./httpInterceptor/httpInterceptorMixin/httpInterceptorMixin";

const app = createApp(App);
/* eslint-disable */

//Directives
app.directive("styleclass", StyleClass);
app.directive("ripple", Ripple);
app.directive("tooltip", Tooltip);

//components
app.component("MenuBar", MenuBar);
app.component("Button", Button);
app.component("Galleria", Galleria);
app.component("Carousel", Carousel);
app.component("InputText", InputText);
app.component("Chip", Chip);
app.component("Dropdown", Dropdown);
app.component("Card", Card);
app.component("MultiSelect", MultiSelect);
app.component("Dialog", Dialog);
app.component("RadioButton", RadioButton);
app.component("Toast", Toast);
app.component("TabView", TabView);
app.component("TabPanel", TabPanel);
app.component("Divider", Divider);
app.component("DataTable", DataTable);
app.component("Column", Column);
app.component("Accordion", Accordion);
app.component("AccordionTab", AccordionTab);
app.component("TextArea", TextArea);
app.component("ScrollPanel", ScrollPanel);
app.component("Paginator", Paginator);

app.use(ToastService);
app.use(PrimeVue, { ripple: true });
app.use(router);
app.mixin(httpInterceptorMixin);

app.component("CustomCarousel", {
  extends: Carousel,
  mounted() {
    this.onTouchMove = function (event) {};
  },
});

app.config.errorHandler = (err, vm) => {};

app.mount("#app");
